var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginDrawToolIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M8.08 20.172v-4.25L18.427 5.6c.2-.2.425-.35.675-.45a1.975 1.975 0 0 1 1.512 0c.242.1.454.25.638.45l1.4 1.4c.2.183.35.396.45.638a1.975 1.975 0 0 1 0 1.512c-.1.25-.25.475-.45.675L12.33 20.172H8.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "evenodd",
  d: "M10.08 18.172h1.4l6.997-6.972-.7-.725-.725-.7-6.972 6.997z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M4.869 7.005c2.73.083 4.881 1.091 4.881 3.245 0 1.75-1.06 2.655-3.617 3.161l-.695.131c-2.065.394-2.688.958-2.688 2.208 0 1.25.764 1.952 2.408 2.17.302.04.585.062.921.074v2.001a11.14 11.14 0 0 1-1.183-.093C2.37 19.568.75 18 .75 15.75c0-2.177 1.326-3.53 4.037-4.116l1.152-.223c1.476-.298 1.811-.537 1.811-1.161C7.75 9.553 6.396 9 4.5 9l.369-1.995z"
}))));
export default SvgPluginDrawToolIcon;